import styled from "styled-components";
import { Button } from "@mui/material";

export const Wrapper = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   height: 100vh;
`

export const FormWrapper = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   padding: 50px 25px 50px;
   border: 1px solid #A09EFF;
   box-shadow: 0px 4px 4px 0px #00000040;
   border-radius: 10px;
   width: 100%;
   max-width: 450px;

   @media (min-width: 768px) {
      padding: 50px 25px 100px;
   }
`

export const Form = styled.form`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   width: 100%;
`

export const Title = styled.h1`
   font-family: Raleway;
   font-size: clamp(20px, 3vw, 27px);
   font-weight: 500;
   line-height: 29.7px;
   margin-bottom: 45px;
   text-align: center;
   color: #333;
`

export const InputWrapper = styled.div`
   width: 100%;
   max-width: 350px;
   &:not(:last-child) {
      margin-bottom: 25px;
   }
`

export const InputName = styled.p`
   font-family: Raleway;
   font-size: 13px;
   font-weight: 800;
   line-height: 14.3px;
   text-align: left;
   margin-bottom: 5px;
   color: #333;
`

export const Input = styled.input`
   border: 1px solid #8E8E8E;
   border-radius: 10px;
   padding: 10px 30px 10px 10px;
   box-shadow: 0px 4px 4px 0px #00000040;
   width: 100%;
   font-size: 14px;
   font-weight: 400;
   transition: all 0.3s ease-in-out;

   &:hover {
      border: 1px solid #A09EFF;
   }

   &:focus {
     border: 1px solid #A09EFF;
   }

   &::placeholder {
      font-family: Raleway;
      font-size: 11px;
      font-weight: 400;
      color: #999;
   }

   &:-webkit-autofill {
      -webkit-text-fill-color: black !important;
   }
`

export const ErrorMessage = styled.p`
   color: red;
   font-size: ${props => (props.notAllowed ? '15px' : '10px')};
   margin: 0px 0px 15px 0px;

   ${props =>
      props.notAllowed &&
      `
      margin: 0px 0px 20px 0px;
   `}
`

export const Btn = styled(Button)`
   border: 1px solid #A09EFF !important;
   background: #A09EFF !important;
   width: 70% !important;
   font-family: Raleway !important;
   font-size: 11px !important;
   font-weight: 900 !important;
   line-height: 12.1px !important;
   color: #000000 !important;
   border-radius: 10px !important;
   padding: 13px 0px !important;
   transition: background 0.3s ease, transform 0.3s ease;

   &:hover {
      background: #8E8E8E;
      transform: scale(1.05);
   }

   &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }
`

export const Logo = styled.img`
   width: 200px;
   height: 70px;
   margin-bottom: 15px;
   @media (min-width: 768px) {
      width: 300px;
      height: 90px;
   }
`

export const InfoMessage = styled.span`
   margin-bottom: 30px;
   font-size: 14px;
   color: #333;
`

export const PasswordWrapper = styled.div`
   display: flex;
   align-items: center;
   position: relative;
`

export const PasswordToggle = styled.div`
   position: absolute;
   right: 10px;
   cursor: pointer;
`

